import { Button } from "components";
import { useFormContext } from "react-hook-form";
import { IoIosSave } from "react-icons/io";
import { FormSetStockType } from "../schemas/setStockByLocationSchemas";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { PERMISION } from "security";

export function CreateSetStock(props: {
    index: number
    refecth?: () => void
}) {

    const api = useApi();

    const { getValues } = useFormContext<FormSetStockType>()

    const onSubmit = () => {
        const data = [getValues(`items.${props.index}`)]
        
        if (data.some(item => item?.mr_unit_id === null)) {
            toast.error("Unit product is required")
            return
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/product-minmax-loc/bulk-upsert", data),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                // props.refecth && props.refecth();
            }).catch(() => {
            }).finally(resolve)
        })

    }

    return (
        <Button
            color="primary"
            permission={PERMISION.INVENTORY.TRANSACTION.SET_STOCK_BY_LOCATION.CREATE}
            onClick={onSubmit}
        >
            <IoIosSave size={20} />
        </Button>
    )
}